import React, { createContext, useContext, useState, useCallback } from 'react';
import WhatsAppLeadModal from '@/components/ui/WhatsAppLeadModal';

interface WhatsAppModalContextType {
  openWhatsAppModal: (source: string, customMessage?: string) => void;
}

const WhatsAppModalContext = createContext<WhatsAppModalContextType | null>(null);

export const useWhatsAppModal = () => {
  const ctx = useContext(WhatsAppModalContext);
  if (!ctx) throw new Error('useWhatsAppModal must be used within WhatsAppModalProvider');
  return ctx;
};

export const WhatsAppModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState('cta');
  const [customMessage, setCustomMessage] = useState<string | undefined>(undefined);

  const openWhatsAppModal = useCallback((src: string, msg?: string) => {
    setSource(src);
    setCustomMessage(msg);
    setOpen(true);
  }, []);

  return (
    <WhatsAppModalContext.Provider value={{ openWhatsAppModal }}>
      {children}
      <WhatsAppLeadModal
        open={open}
        onOpenChange={setOpen}
        source={source}
        customMessage={customMessage}
      />
    </WhatsAppModalContext.Provider>
  );
};
